import axios from "axios";
import { message } from "../common/message"; // 避免重复弹窗
import { Loading } from "element-ui";

const instance = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  timeout: 20000,
});

instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    const needtoken = config.needtoken ?? true;
    if (token && needtoken) {
      config.headers["x-token"] = token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    const response = error.response;
    if (response.status === 401) {
      window.system.$router.replace("/login");
      message({
        message: "请重新登录",
        type: "error",
        duration: 1500,
      });
    } else {
      message({
        message: response?.data?.msg ?? "服务器繁忙,请重试",
        type: "error",
        duration: 1500,
      });
    }
    return Promise.reject(error);
  }
);

function request({
  url,
  method = "post",
  data = {},
  options = {},
  showLoading = true,
}) {
  return new Promise((resolve, reject) => {
    let loading;
    if (showLoading) {
      loading = Loading.service({
        lock: true,
        background: "rgba(0, 0, 0, 0)",
      });
    }

    instance({
      url,
      method,
      data,
      ...options,
    })
      .then((res) => {
        if (options.responseType === "blob") {
          resolve(res);
          return;
        }

        if (res.code === 0) {
          resolve(res.data);
        } else {
          message({
            message: res.msg ?? "服务器繁忙,请重试",
            type: "error",
            duration: 1500,
          });
          reject(res);
        }
      })
      .catch((err) => {
        reject(err);
      })
      .finally(() => {
        if (showLoading) {
          loading.close();
        }
      });
  });
}

export default request;
